import { render } from "./rates.view.vue?vue&type=template&id=0d7a1e20"
import script from "./rates.view.vue?vue&type=script&lang=js"
export * from "./rates.view.vue?vue&type=script&lang=js"

import "./rates.view.vue?vue&type=style&index=0&id=0d7a1e20&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__